import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { AsyncStatus } from '../../../libs/utils/constants/async-status';
import LOGIN_FLOW_ACTIONS from './login-action-types';
import HeaderToken from '../../constants/header-token';
import ILogin from '../../../libs/utils/interfaces/login-interface';

const initialState = {
    asyncStatus: AsyncStatus.INITIAL,
    checkLoginAsyncStatus: AsyncStatus.INITIAL,
    isUserAuthenticated: false,
    hasSkillAuthorization: false,
    firstName: '',
    lastName: '',
    email: '',
    error: null,
    userId: -1,
    education: '',
    facilityId: -1,
    departmentId: -1,
    unitId: -1,
    externalId: -1,
    clientId: -1,
    userRole: {},
    originalRedirectUrl: '',
    clientInfo: { organizationName: '' },
    clientFeatureFlags: {},
    ecrId: '',
} as ILogin;

const loginSlice = createSlice({
    name: 'login',
    initialState,
    reducers: {
        updateLoginStatus: (state: ILogin, { payload }: PayloadAction<any>) => {
            const {
                firstName,
                lastName,
                email,
                isUserAuthenticated,
                hasSkillAuthorization,
                id: userId,
                education,
                facilityId,
                departmentId,
                unitId,
                externalId,
                clientId,
                userRole,
                identityToken,
                originalRedirectUrl,
                clientInfo,
                clientFeatureFlags,
                ecrId,
            } = payload;
            if (isUserAuthenticated) {
                sessionStorage.setItem(
                    HeaderToken.CORE_API_ACCESS_TOKEN_NAME,
                    identityToken
                );
                localStorage.setItem('IS_USER_AUTHENTICATED', 'true');
            }
            return {
                ...state,
                asyncStatus: AsyncStatus.SUCCESS,
                checkLoginAsyncStatus: AsyncStatus.SUCCESS,
                isUserAuthenticated,
                hasSkillAuthorization,
                firstName,
                lastName,
                email,
                userId,
                education,
                facilityId,
                departmentId,
                unitId,
                externalId,
                clientId,
                userRole,
                originalRedirectUrl,
                clientInfo,
                clientFeatureFlags,
                ecrId,
            };
        },
        authAPIFailed: (state: ILogin, { payload }: PayloadAction<any>) => {
            const { error, isUserAuthenticated } = payload;
            return {
                ...state,
                asyncStatus: AsyncStatus.FAILURE,
                checkLoginAsyncStatus: AsyncStatus.FAILURE,
                isUserAuthenticated,
                error,
                firstName: payload?.firstName || '',
                lastName: payload?.lastName || '',
            };
        },
        cancelledAsyncLogin: (state: ILogin) => ({
            ...state,
            asyncStatus: AsyncStatus.CANCELLED,
        }),
    },
    extraReducers: {
        [LOGIN_FLOW_ACTIONS.LOGIN_FLOW_PENDING]: (state: ILogin) => {
            state.asyncStatus = AsyncStatus.LOADING;
            state.checkLoginAsyncStatus = AsyncStatus.LOADING;
        },
        [LOGIN_FLOW_ACTIONS.LOGIN_CHECK_FLOW_PENDING]: (state: ILogin) => {
            state.checkLoginAsyncStatus = AsyncStatus.LOADING;
        },
        [LOGIN_FLOW_ACTIONS.LOGIN_CHECK_FLOW_REJECTED]: (state: ILogin) => {
            state.checkLoginAsyncStatus = AsyncStatus.FAILURE;
        },
    },
});

export const { updateLoginStatus, authAPIFailed, cancelledAsyncLogin } =
    loginSlice.actions;
export default loginSlice.reducer;
